module.exports = __webpack_public_path__ + "media/03_ASANBudapest-Custom03.f18c5575.mp3";